<lib-row-with-two-columns
  [breakpoint]="breakpointService.isPhoneViewObservable"
  [column1FxFlex]="
    (breakpointService.isTabletViewObservable | async) ? '40%' : '30%'
  "
  [column2FxFlex]="
    (breakpointService.isTabletViewObservable | async) ? '60%' : '70%'
  "
  [fxLayoutGap]="
    (breakpointService.isPhoneViewObservable | async) ? '0px' : '20px'
  "
  [formGroup]="submitForm"
>
  <mat-form-field col-1>
    <mat-label>{{
      'phone-number-input.text.country-code' | translate
    }}</mat-label>

    <input
      matInput
      [matAutocomplete]="isoCodeAutoComplete"
      [formControlName]="FORM_NAME.PHONE_COUNTRY_CODE"
    />
    <mat-autocomplete #isoCodeAutoComplete="matAutocomplete">
      <mat-option
        *ngFor="let isoCode of filteredIsoCodes"
        [value]="isoCode.phoneCountryCode"
      >
        <img
          class="flag-icon"
          alt="{{ isoCode.isoCode }}"
          src="/assets/svg-country-flags/{{
            isoCode.isoCode?.toLowerCase()
          }}.svg"
        />
        {{ isoCode.isoCode }} ({{ isoCode.phoneCountryCode }})
      </mat-option>
    </mat-autocomplete>

    <mat-error>
      <div fxLayout="row" fxLayoutAlign="start center" fxFlexFill>
        {{
          (!!controlPhoneCountryCode.value
            ? 'phone-number-input.text.country-code-invalid'
            : 'phone-number-input.text.country-code-required'
          ) | translate
        }}
      </div>
    </mat-error>
  </mat-form-field>

  <mat-form-field col-2>
    <mat-label>{{ 'phone-number-input.text.phone-nr' | translate }}</mat-label>
    <input
      class="input-container"
      [formControlName]="FORM_NAME.PHONE_NR"
      matInput
      type="number"
      pattern="\d*"
      (paste)="pastePhoneNrEventHandler($event)"
    />
    <mat-error *ngIf="controlPhoneNr.dirty">
      <div
        *ngIf="!isValid"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxFlexFill
      >
        {{
          (!!controlPhoneNr.value
            ? 'phone-number-input.text.phone-nr-invalid'
            : 'phone-number-input.text.phone-nr-required'
          ) | translate
        }}
      </div>
    </mat-error>
  </mat-form-field>
</lib-row-with-two-columns>
